/**
 * @file auth.ts
 * @module api/apiJSON/auth
 * @description Defines auth API request configuration and payload helpers.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import {
  IForgotPassword,
  ILoginData,
  IResetPassword,
  IVerify,
  IVerifyPassword,
} from "../../types";
export const APIJSON = {
  login: ({ email, password }: ILoginData) => {
    return {
      email: email,
      password: password,
    };
  },
  verify: ({ code }: IVerify) => {
    return { code: code };
  },
  forgotPassword: ({ email, phone, phoneCountry }: IForgotPassword) => {
    if (email) {
      return {
        email: email,
      };
    }
    if (phone && phoneCountry) {
      return {
        phoneCountry: phoneCountry,
        phone: phone,
      };
    }
  },
  verifyPassword: ({ email, phone, phoneCountry, code }: IVerifyPassword) => {
    if (email) {
      return {
        email: email,
        code: code,
      };
    }
    if (phone && phoneCountry) {
      return {
        phoneCountry: phoneCountry,
        phone: phone,
        code: code,
      };
    }
  },
  resetPassword: ({
    email,
    phone,
    phoneCountry,
    code,
    newPassword,
  }: IResetPassword) => {
    if (email) {
      return {
        email: email,
        code: code,
        newPassword: newPassword,
      };
    }
    if (phone && phoneCountry) {
      return {
        phoneCountry: phoneCountry,
        phone: phone,
        code: code,
        newPassword: newPassword,
      };
    }
  },
};
